let handler: (() => void) | null = null;

export const setConnectionErrorHandler = (fn: (() => void) | null) => {
    handler = fn as () => void;
};

export const notifyConnectionError = () => handler?.();